import { app } from "@/app.context";
import {
  linkMatchesActivityTypes,
  linkMatchesCities,
  linkMatchesModes,
  linkMatchesMonths,
  modeOnline,
  modePhysical,
} from "@/views/components/filters/filter-functions";
import { createFilterObject } from "@/views/components/filters/FilterSection.types.";
import {
  PublicActivityLocationDTO,
  PublicActivityRegistrationLinkDTO,
} from "lib/eduConfigurationServiceClient";

export default function createLinkFilter(
  links: PublicActivityRegistrationLinkDTO[],
  activityLocations: PublicActivityLocationDTO[],
) {
  const type = createFilterObject(
    "type",
    app.texts.activity.type,
    linkMatchesActivityTypes,
    links,
    (link) => link.type,
  );

  const city = createFilterObject(
    "city",
    app.texts.activity.city,
    linkMatchesCities(activityLocations),
    links,
    (link) =>
      link.activityLocationIds.map(
        (id) => activityLocations.find((loc) => loc.id === id)?.city,
      ),
  );

  const mode = createFilterObject(
    "mode",
    app.texts.activity.participationMode,
    linkMatchesModes,
    links,
    (link) => (link.isOnline ? modeOnline.value : modePhysical.value),
  );

  const month = createFilterObject(
    "month",
    app.texts.activity.month,
    linkMatchesMonths,
    [], // options added below
    () => undefined,
  );

  // the month filter should not be sorted alphabetically, so needs a different sorting implementation
  // technically it doesn't actually need to be sorted as links are fetched in this order already
  // but it's not robust to rely on that, so we sort the filter anyway.
  links
    .map((link) => link.startDateTime)
    .sort((a, b) => a.toMillis() - b.toMillis())
    .forEach((option) => (month.options[option.toFormat("MMMM yyyy")] = false));

  return [type, city, month, mode];
}
